// axiosInstance.js
import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://api.manjitjewellers.com/",
});

export default axiosInstance;

// export const weburl = "https://manjit-jewellers-backend.onrender.com/";
export const weburl = "https://api.manjitjewellers.com/";
export const testurl = "https://api.manjitjewellers.com/";
export const ImageServer = "https://cloud.manjitjewellers.com/";

export const shopurl = "https://admin.manjitjewellers.com/";
export const mainurl = "https://app.manjitjewellers.com/";
export const fronturl = "https://app.manjitjewellers.com/";


export const keyLogin = process.env.REACT_APP_LOGIN_KEY;